// /start 自助健檢漏斗的三語字串（SS03·2026-08-23）。
//
// 為什麼有這個檔：/quanbrand/ 上了 en／ja，主 CTA 卻落在全中文的 /start ——
// **讀者以為自己在一條英文動線上，走到第二步才發現不是。**
// 那比整條都是中文更糟。
//
// 🔴 這一波只加語言，不改內容。zh 欄位是既有文案**逐字搬過來**的；
//    要改文案是另一件事、另一個變因。
//
// 2026-08-23 BV01：三賽道框架作廢（Allen 7/26 裁決）。`lane`／`waitlist` 已整組移除，
// 換成 `fields`（三場域·**說明不是選項**）。三場域文字**逐字取自已上線的
// quanturing.ai/quanbrand/**，不是在這裡另寫 —— 同一個敘事存在兩份就會漂移，
// 而「產品端還在講作廢的框架」正是這張工單要修的病。
// 🔴 en／ja 是既有中文的翻譯，不是重新發想的行銷稿。
//
// ⚠️ 尚未三語化、且**刻意留在中文**的兩塊（已回報 gcp-pro）：
//    1. 健檢報告的逐項內容（項目名／損失／依據）—— 由後端 qbplatform/audit.py
//       產生，46 個判定點的文案是另一個量級的工，且屬對外敘事
//    2. 顧問 bot 的回答 —— 已改成把 lang 傳給後端，由模型用該語言回答

export const startStrings = {
  zh: {
    title: '免費品牌健檢 · QuanBrand',
    signOut: '登出',
    back: '← 返回',
    hero: {
      title: '你的顧客在網路上\n找得到你嗎？你排在誰後面？',
      sub: '免費體檢你的品牌網站——一眼看出該做而沒做的缺口，以及它正讓你流失什麼。',
      gisLocale: 'zh_TW',
      signinLoading: '登入服務初始化中…',
      switchAccount: '使用其他 Google 帳號登入',
      signinFallback: '登入按鈕沒有載入。請檢查瀏覽器的第三方登入設定（FedCM／第三方 Cookie），或改用另一個瀏覽器；也可以直接從下方連結選擇帳號。',
      loginNote: '使用 Google 登入即可開始。你的 email 僅用於本服務與後續聯繫，不作他用。',
      privacySummary: '資料使用說明',
      privacy: [
        ['我們收什麼：', '你的 Google 帳號 email 與姓名、你指定要體檢的品牌與網址、以及你與顧問的對話內容。'],
        ['用在哪：', '產生你的健檢報告與競品對照、以及在你主動表達需求時由我們團隊與你聯繫。不販售、不提供給第三方。'],
        ['存多久：', '健檢報告會一直保留（供你回看與追蹤變化）；顧問對話保留 90 天後自動刪除。'],
        ['競品資料：', '僅取自 Google 地圖等公開來源與對方的公開網站，我們不會存取任何人的後台。'],
        ['想刪除：', '來信 ask@quanturing.ai 即可要求刪除你的資料。'],
      ],
    },
    home: {
      title: '我的品牌',
      subHas: '你的健檢紀錄會一直留著，隨時回來看。',
      subEmpty: '還沒有健檢紀錄——開始你的第一次品牌體檢。',
      chatQuota: '顧問對話',
      trackingQuota: '追蹤品牌', compareQuota: '對手比對',
      today: '（今日）', month: '（本月）', subscribed: '訂閱中',
      probedAt: '體檢於', compared: ' · 已比對手',
      addMore: '體檢另一個品牌', addFirst: '開始免費體檢',
    },
    // 三場域＝**說明**，不是選項。客戶不需要先挑一種比法，三個是同時量的。
    // 文字逐字取自 quanturing.ai/quanbrand/ 的 #content-zh。
    fields: {
      title: '我們會在這三個地方各量一次',
      items: [
        ['🔍', 'Google 搜尋', '有人搜你的名字、或搜「你這種服務」的時候，你出現嗎、排在第幾？'],
        ['📍', 'Google 地圖', '有人在地圖上找的時候，你出現嗎、資訊完整嗎、評論夠不夠撐住信任？'],
        ['🤖', 'AI 推薦', '有人直接問 AI「推薦哪一家」的時候，AI 會不會講到你？'],
      ],
    },
    bind: {
      back: '← 我的品牌',
      title: '你的品牌是？',
      sub: '兩樣都填最準。只有其中一樣也可以。',
      nameLabel: '公司／店家名稱',
      namePlaceholder: '例：一心鍋物 三重',
      urlLabel: '官網網址',
      urlPlaceholder: '例：example.com.tw',
      urlHelp: '沒有 Google 商家檔案也沒關係 —— 有官網就檢查得了。',
      searching: '查詢中…', search: '查詢',
      needSomething: '至少填一樣：名稱或網址。',
      noResult: '在 Google 地圖上找不到這個名稱的商家檔案。這不代表你的品牌有問題 —— 很多公司本來就沒有商家檔案。填上官網網址就能繼續。',
      running: '體檢進行中，請稍候…',
    },
    confirm: {
      title: '是不是要找這一間？',
      sub: '確認之後才會開始體檢。',
      viaUrl: '直接檢查這個網站',
      viaPlace: '來自 Google 地圖的商家檔案',
      gbpMatched: '✓ 有找到對應的 Google 商家檔案 —— 地圖那一格會一起納入評分',
      gbpNone: '這次沒有找到對應的商家檔案。網站與 AI 推薦兩格照常評分；'
        + '地圖那一格會標成「查無」，不是 0 分。',
      gbpUnknown: '你沒有填名稱，所以我們還沒去找商家檔案。'
        + '有的話補上名稱，就能連同商家檔案一起納入評分。',
      noSite: '這筆沒有官網 —— 網站健檢需要網址',
      yes: '是，開始體檢',
      no: '不是，重新找',
      more: '都不是？改用官網網址',
    },
    result: {
      back: '← 我的品牌',
      scoreLabel: '網站健檢分數', brandFallback: '品牌', grade: '等級',
      tally: (p, w, f) => `通過 ${p} · 待優化 ${w} · 未處理 ${f} 項`,
      topTitle: '最該補的三個缺口（該做而沒做的損失）',
      loss: '損失：', evidence: '依據：',
      findRivals: '🔍 找出對手，比一比',
      findRivalsAgain: '重新挑對手比一比',
      findingRivals: '查詢同業中…',
      chatCta: '💬 跟顧問聊聊怎麼補這些缺口',
    },
    pick: {
      back: '← 回健檢結果',
      title: '想跟誰比一比？',
      sub: '挑一家，我們用同一套檢查表幫你們各打一次分。',
      nearbyTitle: '你周邊的同業（Google 地圖公開資料）',
      noNearby: '這裡沒有列出周邊同業 —— 你的品牌沒有綁定地圖商家，或附近沒有同類型的商家。',
      noNearbyOk: '這不影響比分：對手只要有官網就比得了。',
      manualTitle: '自己指定對手',
      manualSub: '不必是同商圈的。你認為誰是對手，就比誰。',
      rivalName: '對手名稱',
      rivalNamePlaceholder: '例：某某科技',
      rivalUrl: '對手網址',
      rivalUrlPlaceholder: '例：competitor.com',
      rivalNeedUrl: '請填對手的網址 —— 比分是對網站打的。',
      compareThis: '用這個對手比一比',
      analyzing: '對照分析中，請稍候…',
    },
    compare: {
      title: '你 vs 對手',
      sub: '用一模一樣的檢查表，幫你跟對手各打了一次分。',
      rank: (r, t) => `你排第 ${r}／${t} 名。`,
      you: '你', noRating: '無評價', noWebsite: ' · 沒有官網', noSite: '無網站',
      // 🔴 「沒有評價」與「我們沒去比對商家檔案」是兩件事。
      //    自己指定的對手我們沒查過 Places —— 印「無評價」等於替對方
      //    宣稱一件我們沒查證的事。
      gbpNotChecked: '未比對商家檔案',
      diffTitle: '一項一項比下來',
      theyWin: (n) => `他有、你沒有的 ${n} 項`,
      youWin: (n) => `你有、他沒有的 ${n} 項`,
      noDiff: '這一項一項比下來，你們沒有差異 —— 分數差在程度，不在有無。',
      avg: (a, m) => `對手網站健檢均分 ${a}，你是 ${m}。`,
      avgTail: '分數只是體質——真正決定生意的是「顧客找不找得到你、找到後信不信你」。',
      chatCta: '💬 想知道怎麼追上？跟顧問聊聊',
      snapshot: '這只是單次快照——想每期都看到對手的動作？',
    },
    limit: { title: '免費版額度已用完', back: '← 回我的品牌' },
    chat: {
      greeting: '我看過你的健檢報告了。想從哪個部分聊起？也可以直接告訴我你目前最頭痛的問題——例如客人變少、被對手比下去、還是不知道從哪裡改起。',
      title: '品牌優化顧問',
      sub: '所有建議都來自你剛剛那份健檢報告 · 對話保留 90 天',
      thinking: '顧問思考中…',
      leadSent: '✓ 已把你的健檢報告與需求整理給團隊（我們會用你登入的 email 與你聯繫）',
      placeholder: '輸入訊息…（Enter 送出）',
      send: '送出',
      failed: (m) => `（顧問暫時無法回覆：${m}）`,
    },
    err: '錯誤',
  },

  en: {
    title: 'Free brand check-up · QuanBrand',
    signOut: 'Sign out',
    back: '← Back',
    hero: {
      title: 'Can your customers find you\nonline — or do they find your rivals first?',
      sub: 'A free check-up of your brand website. See in one glance what is missing, and what that gap is costing you.',
      gisLocale: 'en',
      signinLoading: 'Starting the sign-in service…',
      switchAccount: 'Sign in with a different Google account',
      signinFallback: 'The sign-in button did not load. Check the third-party sign-in settings of your browser (FedCM / third-party cookies) or try another browser — or pick an account from the link below.',
      loginNote: 'Sign in with Google to start. Your email is used only for this service and any follow-up — nothing else.',
      privacySummary: 'How we use your data',
      privacy: [
        ['What we collect: ', 'Your Google account email and name, the brand and URL you ask us to check, and your conversation with the advisor.'],
        ['What we use it for: ', 'Generating your check-up report and competitor comparison, and — when you tell us you want it — letting our team contact you. We never sell it or pass it to third parties.'],
        ['How long we keep it: ', 'Check-up reports are kept indefinitely so you can revisit them and track changes; advisor conversations are deleted automatically after 90 days.'],
        ['Competitor data: ', 'Taken only from public sources such as Google Maps and the competitor\u2019s own public website. We never access anyone\u2019s back office.'],
        ['Deletion: ', 'Email ask@quanturing.ai to have your data deleted.'],
      ],
    },
    home: {
      title: 'My brands',
      subHas: 'Your check-up records stay here. Come back any time.',
      subEmpty: 'No check-ups yet — start your first one.',
      chatQuota: 'Advisor chats',
      trackingQuota: 'Brands tracked', compareQuota: 'Competitor runs',
      today: ' (today)', month: ' (this month)', subscribed: 'Subscribed',
      probedAt: 'Checked on', compared: ' · compared',
      addMore: 'Check another brand', addFirst: 'Start a free check-up',
    },
    fields: {
      title: 'We measure each of these three places',
      items: [
        ['🔍', 'Google Search', 'When someone searches your name — or searches for what you do — do you appear, and where?'],
        ['📍', 'Google Maps', 'When someone looks on the map, do you appear? Is your information complete? Do the reviews carry enough trust?'],
        ['🤖', 'AI recommendations', 'When someone asks an AI assistant which company to use, does it mention you — or your competitor?'],
      ],
    },
    bind: {
      back: '← My brands',
      title: 'Which brand is yours?',
      sub: 'Both fields give the best result. One is enough to start.',
      nameLabel: 'Business name',
      namePlaceholder: 'e.g. Ichishin Hotpot Sanchong',
      urlLabel: 'Website',
      urlPlaceholder: 'e.g. example.com.tw',
      urlHelp: 'No Google Business Profile? That is fine — a website is enough to run the check.',
      searching: 'Searching…', search: 'Search',
      needSomething: 'Enter at least one: a name or a website.',
      noResult: 'No business profile with that name on Google Maps. That says nothing about your brand — plenty of companies simply do not have one. Add your website and we can continue.',
      running: 'Running the check-up, one moment…',
    },
    confirm: {
      title: 'Is this the one?',
      sub: 'Nothing runs until you confirm.',
      viaUrl: 'We will check this website directly',
      viaPlace: 'From a Google Maps business profile',
      gbpMatched: '✓ Found the matching Google Business Profile — it will be scored with the rest',
      gbpNone: 'No matching business profile this time. Search and AI recommendations are '
        + 'still scored; the Maps field is marked "not found", which is not a zero.',
      gbpUnknown: 'You left the name blank, so we have not looked for a business profile yet. '
        + 'Add the name and we can score it too.',
      noSite: 'No website on this listing — the website check needs a URL',
      yes: 'Yes, start the check-up',
      no: 'No, search again',
      more: 'None of these? Use the website instead',
    },
    result: {
      back: '← My brands',
      scoreLabel: 'website check-up score', brandFallback: 'Brand', grade: 'Grade',
      tally: (p, w, f) => `${p} passed · ${w} to improve · ${f} missing`,
      topTitle: 'The three biggest gaps (what not doing them costs you)',
      loss: 'Cost: ', evidence: 'Basis: ',
      findRivals: '🔍 Find my competitors and compare',
      findRivalsAgain: 'Pick a different competitor',
      findingRivals: 'Looking for peers…',
      chatCta: '💬 Ask the advisor how to close these gaps',
    },
    pick: {
      back: '← Back to results',
      title: 'Who do you want to be compared with?',
      sub: 'Pick one and we will score both of you with the identical checklist.',
      nearbyTitle: 'Peers near you (public Google Maps data)',
      noNearby: 'No nearby peers listed — your brand is not linked to a Maps business profile, or there are no similar businesses nearby.',
      noNearbyOk: 'This does not affect the comparison: any competitor with a website can be scored.',
      manualTitle: 'Name your own competitor',
      manualSub: 'They do not have to be down the street. Whoever you consider a competitor, we will score.',
      rivalName: 'Competitor name',
      rivalNamePlaceholder: 'e.g. Acme Corp',
      rivalUrl: 'Competitor website',
      rivalUrlPlaceholder: 'e.g. competitor.com',
      rivalNeedUrl: 'Please enter the competitor website — the score is measured on the site.',
      compareThis: 'Compare against this one',
      analyzing: 'Running the comparison, one moment…',
    },
    compare: {
      title: 'You vs your competitor',
      sub: 'Both of you scored with the identical checklist.',
      rank: (r, t) => `You rank ${r} of ${t}.`,
      you: 'You', noRating: 'No ratings', noWebsite: ' · no website', noSite: 'no site',
      gbpNotChecked: 'business profile not checked',
      diffTitle: 'Item by item',
      theyWin: (n) => `${n} they have and you do not`,
      youWin: (n) => `${n} you have and they do not`,
      noDiff: 'Item by item there is no difference — the gap is in degree, not in presence.',
      avg: (a, m) => `Competitor average is ${a}; you are at ${m}.`,
      avgTail: 'The score is only your baseline — what actually decides the business is whether customers can find you, and whether they trust you once they do.',
      chatCta: '💬 Want to know how to catch up? Talk to the advisor',
      snapshot: 'This is a single snapshot — want to see what your competitors do every period?',
    },
    limit: { title: 'Free allowance used up', back: '← Back to my brands' },
    chat: {
      greeting: 'I have read your check-up report. Where would you like to start? You can also just tell me what is worrying you most right now — fewer customers, being out-ranked by a competitor, or simply not knowing where to begin.',
      title: 'Brand advisor',
      sub: 'Every suggestion comes from the report you just ran · conversations kept for 90 days',
      thinking: 'The advisor is thinking…',
      leadSent: '✓ Your report and request have been passed to our team (we will reach you at the email you signed in with)',
      placeholder: 'Type a message… (Enter to send)',
      send: 'Send',
      failed: (m) => `(The advisor cannot reply right now: ${m})`,
    },
    err: 'Error',
  },

  ja: {
    title: '無料ブランド診断 · QuanBrand',
    signOut: 'ログアウト',
    back: '← 戻る',
    hero: {
      title: 'お客様はネット上で\n御社を見つけられますか？誰の後ろに並んでいますか？',
      sub: 'ブランドサイトを無料で診断します。やるべきなのに手つかずの箇所と、それが何を失わせているかが一目でわかります。',
      gisLocale: 'ja',
      signinLoading: 'ログインサービスを初期化しています…',
      switchAccount: '別の Google アカウントでログイン',
      signinFallback: 'ログインボタンが読み込まれませんでした。ブラウザのサードパーティログイン設定（FedCM／サードパーティ Cookie）を確認するか、別のブラウザをお試しください。下のリンクからアカウントを選ぶこともできます。',
      loginNote: 'Google でログインすると開始できます。メールアドレスは本サービスとその後のご連絡のみに使用します。',
      privacySummary: 'データの取り扱いについて',
      privacy: [
        ['取得する情報：', 'Google アカウントのメールアドレスと氏名、診断対象としてご指定いただいたブランドと URL、アドバイザーとの会話内容。'],
        ['利用目的：', '診断レポートと競合比較の生成、およびお客様からご要望があった場合の当社からのご連絡。販売も第三者提供も行いません。'],
        ['保存期間：', '診断レポートは継続して保存します（見返しと変化の追跡のため）。アドバイザーとの会話は 90 日後に自動削除されます。'],
        ['競合データ：', 'Google マップ等の公開情報と相手先の公開サイトのみを参照します。他社の管理画面にアクセスすることはありません。'],
        ['削除のご依頼：', 'ask@quanturing.ai までご連絡いただければ削除いたします。'],
      ],
    },
    home: {
      title: 'マイブランド',
      subHas: '診断記録はそのまま残ります。いつでもご覧いただけます。',
      subEmpty: 'まだ診断記録がありません——最初の診断を始めましょう。',
      chatQuota: 'アドバイザー対話',
      trackingQuota: '追跡ブランド', compareQuota: '競合比較',
      today: '（本日）', month: '（今月）', subscribed: '契約中',
      probedAt: '診断日', compared: ' · 競合比較済み',
      addMore: '別のブランドを診断', addFirst: '無料診断を始める',
    },
    fields: {
      title: 'この三つの場で、それぞれ測ります',
      items: [
        ['🔍', 'Google 検索', '名前で検索されたとき、あるいは「その種のサービス」で検索されたとき、あなたは出てきますか。何番目ですか。'],
        ['📍', 'Google マップ', '地図で探されたとき、表示されますか。情報は揃っていますか。クチコミは信頼を支えるだけありますか。'],
        ['🤖', 'AI のおすすめ', 'AI に直接「どこがおすすめ？」と聞かれたとき、AI はあなたに触れますか。'],
      ],
    },
    bind: {
      back: '← マイブランド',
      title: '御社のブランドは？',
      sub: '両方あると最も正確です。どちらか一方でも始められます。',
      nameLabel: '会社名・店舗名',
      namePlaceholder: '例：一心鍋物 三重',
      urlLabel: '公式サイト URL',
      urlPlaceholder: '例：example.com.tw',
      urlHelp: 'Google ビジネス プロフィールがなくても大丈夫です —— 公式サイトがあれば診断できます。',
      searching: '検索中…', search: '検索',
      needSomething: '名称か URL、どちらか一方は入力してください。',
      noResult: 'その名称の Google ビジネス プロフィールが見つかりませんでした。ブランドに問題があるという意味ではありません —— そもそも登録していない会社は多くあります。公式サイトの URL を入れれば続行できます。',
      running: '診断を実行中です。少々お待ちください…',
    },
    confirm: {
      title: 'こちらでよろしいですか？',
      sub: '確認いただくまで診断は始まりません。',
      viaUrl: 'このサイトを直接診断します',
      viaPlace: 'Google マップのビジネス プロフィールより',
      gbpMatched: '✓ 対応する Google ビジネス プロフィールが見つかりました —— マップの評価にも反映します',
      gbpNone: '今回は対応するビジネス プロフィールが見つかりませんでした。検索と AI おすすめの'
        + '二つは通常どおり評価します。マップの欄は「該当なし」と表示され、0 点ではありません。',
      gbpUnknown: '名称が未入力のため、ビジネス プロフィールはまだ探していません。'
        + '入力いただければ併せて評価できます。',
      noSite: 'この登録には公式サイトがありません —— サイト診断には URL が必要です',
      yes: 'はい、診断を開始',
      no: 'いいえ、探し直す',
      more: 'どれでもない？ URL で指定する',
    },
    result: {
      back: '← マイブランド',
      scoreLabel: 'サイト診断スコア', brandFallback: 'ブランド', grade: '評価',
      tally: (p, w, f) => `合格 ${p} · 要改善 ${w} · 未対応 ${f} 項目`,
      topTitle: '最も埋めるべき 3 つの欠落（やらないことで失っているもの）',
      loss: '損失：', evidence: '根拠：',
      findRivals: '🔍 競合を見つけて比較する',
      findRivalsAgain: '別の競合を選び直す',
      findingRivals: '同業を検索中…',
      chatCta: '💬 埋め方をアドバイザーに相談する',
    },
    pick: {
      back: '← 診断結果に戻る',
      title: 'どこと比較しますか？',
      sub: '一社お選びいただくと、まったく同じチェックリストで双方を採点します。',
      nearbyTitle: '周辺の同業（Google マップの公開情報）',
      noNearby: '周辺の同業は表示されていません —— ビジネス プロフィールが紐付いていないか、近隣に同種の店舗がありません。',
      noNearbyOk: '比較には影響しません：公式サイトさえあれば採点できます。',
      manualTitle: '競合を自分で指定する',
      manualSub: '同じ商圏である必要はありません。御社が競合と考える相手を採点します。',
      rivalName: '競合の名称',
      rivalNamePlaceholder: '例：某社テクノロジー',
      rivalUrl: '競合のサイト URL',
      rivalUrlPlaceholder: '例：competitor.com',
      rivalNeedUrl: '競合のサイト URL を入力してください —— 採点はサイトに対して行います。',
      compareThis: 'この競合と比較する',
      analyzing: '比較分析中です。少々お待ちください…',
    },
    compare: {
      title: '御社 vs 競合',
      sub: 'まったく同じチェックリストで双方を採点しました。',
      rank: (r, t) => `御社は ${t} 社中 ${r} 位です。`,
      you: '御社', noRating: '評価なし', noWebsite: ' · 公式サイトなし', noSite: 'サイトなし',
      gbpNotChecked: 'ビジネス プロフィール未照合',
      diffTitle: '項目ごとの比較',
      theyWin: (n) => `相手にあって御社にないもの ${n} 件`,
      youWin: (n) => `御社にあって相手にないもの ${n} 件`,
      noDiff: '項目ごとに見ると差はありません —— 差は有無ではなく程度にあります。',
      avg: (a, m) => `競合サイトの平均は ${a} 点、御社は ${m} 点です。`,
      avgTail: 'スコアはあくまで体質です——商売を決めるのは「お客様が見つけられるか、見つけたあと信頼できるか」です。',
      chatCta: '💬 追いつく方法をアドバイザーに聞く',
      snapshot: 'これは一時点のスナップショットです——毎期の競合の動きも追いますか？',
    },
    limit: { title: '無料枠を使い切りました', back: '← マイブランドに戻る' },
    chat: {
      greeting: '診断レポートを拝見しました。どこからお話ししましょうか？いま一番お困りのこと——客足が減った、競合に抜かれた、どこから手をつければよいか分からない——を直接お聞かせいただいても構いません。',
      title: 'ブランド最適化アドバイザー',
      sub: 'すべての提案は先ほどの診断レポートに基づきます · 会話は 90 日間保存',
      thinking: 'アドバイザーが考えています…',
      leadSent: '✓ 診断レポートとご要望を担当チームに引き継ぎました（ログインされたメールアドレスへご連絡します）',
      placeholder: 'メッセージを入力…（Enter で送信）',
      send: '送信',
      failed: (m) => `（アドバイザーが応答できません：${m}）`,
    },
    err: 'エラー',
  },
}

/** 取該語言的字串包。**不認得的語言回 zh**（SS03 驗收格 5：?lang=zz 要回退不是空白）。 */
export function startT(lang) {
  return startStrings[lang] || startStrings.zh
}
